import { Routes } from '@angular/router';
import { PoolExplorerComponent } from './components/pool-explorer/pool-explorer.component';
import { StakingDashboardComponent } from './components/staking-dashboard/staking-dashboard.component';


export const routes: Routes = [
  { path: '', component: PoolExplorerComponent },
  { path: 'pool/:id', component: StakingDashboardComponent },

  { path: '**', redirectTo: '' }
];
